import { useEffect, useState } from "react";
import { API_CALLS } from "../../../../../../API/api_calls";
import { Modal, SchedulePostModal } from "../../../../../Common";
import { scheduledPostUtils } from "../../../../../Common/SchedulePostModal/utils";
import { DraftsModalProps } from "./DraftsModal";
import DraftModalContent from "./draftModalContent";

const DraftsModal = ({
  selectedTabIndex,
  setSelectedTabIndex,
  setIsDraftModalOpen,
}: DraftsModalProps.IProps) => {
  const [schedulePostOpen, setSchedulePostOpen] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState("");
  const [schedulePostId, setSchedulePostId] = useState("");

  useEffect(() => {
    if (!schedulePostOpen) {
      selectedTabIndex === 0 && API_CALLS.ARTICLE.listArticleDrafts();
      selectedTabIndex === 1 && API_CALLS.ARTICLE.listScheduledArticles();
      selectedTabIndex === 2 && API_CALLS.ARTICLE.listPublishedArticles();
    }
  }, [selectedTabIndex, schedulePostOpen]);

  return (
    <Modal
      type="Pages"
      CloseButtonPosition="right"
      setCloseButton={setIsDraftModalOpen}
      showCloseButton={!schedulePostOpen}
      maxWidth={schedulePostOpen ? 496 : 464}
    >
      {schedulePostOpen ? (
        <SchedulePostModal
          title="Schedule Article"
          setSchedulePostOpen={setSchedulePostOpen}
          deliveryDate={deliveryDate}
          onSubmit={(values) => {
            API_CALLS.ARTICLE[
              selectedTabIndex
                ? "rescheduleAScheduledArticleDraft"
                : "publishArticleDraft"
            ](
              schedulePostId,
              scheduledPostUtils.createDate(values).toISOString()
            ).then(() => setSchedulePostOpen(false));
          }}
        />
      ) : (
        <DraftModalContent
          setIsDraftModalOpen={setIsDraftModalOpen}
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={setSelectedTabIndex}
          setDeliveryDate={setDeliveryDate}
          setSchedulePostOpen={setSchedulePostOpen}
          setSchedulePostId={setSchedulePostId}
        />
      )}
    </Modal>
  );
};

export default DraftsModal;
